import React from 'react';
import { Flex, Typography, Card, Divider } from 'antd';

import { Course } from '../Course';

import { semesterStruct } from './struct';
import { Supervision } from '../Course_Supervision';

const { Title } = Typography;

export const Semester = ({
  semesterDetail,
  teaching,
  supervision,
}) => {

  const { semester } = semesterDetail;

  return (
    <Card {...semesterStruct.wrapper}>
      <Flex {...semesterStruct.header}>

        <Flex {...semesterStruct.headline}>
          <Title {...semesterStruct.title}>
            Semester~
            {semester === 1
              ? 'Spring'
              : semester === 2
                ? 'Summer'
                : semester === 3
                  ? 'Autumn'
                  : ''}
          </Title>
        </Flex>

      </Flex>
      <br />

      {/* Table A ~ Teaching Evaluation */}
      {teaching ? (
        <>
          <Title level={5} style={{ marginBottom: 12 }}>
            Teaching Evaluation
          </Title>
          <Course
            courses={teaching}
            semesterName={semester}
          />
        </>
      ) : (
        <></>
      )}

      <Divider style={{ margin: '20px 0' }} />

      {/* Table B ~ Supervision */}
      {supervision ? (
        <>
          <Title level={5} style={{ marginBottom: 12 }}>
            Supervision
          </Title>
          <Supervision
            courses={supervision}
            semesterName={semester}
          />
        </>
      ) : (
        <></>
      )}
    </Card>
  );
};
